import { render, staticRenderFns } from "./RisingStars.vue?vue&type=template&id=7977a2b0"
import script from "./rising-stars.ts?vue&type=script&lang=ts&external"
export * from "./rising-stars.ts?vue&type=script&lang=ts&external"
import style0 from "./rising-stars.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports